
export default {
  // 得到现在的年-月-日 时:分:秒
  getNowDate () {
    const nowYear = new Date().getFullYear();
    const nowMonth = (new Date().getMonth() + 1)
      .toString()
      .padStart(2, 0);
    const nowDay = new Date()
      .getDate()
      .toString()
      .padStart(2, 0);
    const nowHours = new Date().getHours().toString().padStart(2, 0);
    const nowMinute = new Date().getMinutes().toString().padStart(2, 0);
    const nowgetSeconds = new Date().getSeconds().toString().padStart(2, 0);
    const nowTime = `${nowYear}-${nowMonth}-${nowDay} ${nowHours}:${nowMinute}:${nowgetSeconds}`;
    return nowTime
  },
  // 几天前的日期
  getDay(day){
    var today = new Date();
    var targetday_milliseconds=today.getTime() + 1000*60*60*24*day;
    today.setTime(targetday_milliseconds); //注意，这行是关键代码
    var tYear = today.getFullYear();
    var tMonth = today.getMonth();
    var tDate = today.getDate();
    tMonth = this.doHandleMonth(tMonth + 1);
    tDate = this.doHandleMonth(tDate);
    return tYear + "-" + tMonth + "-" + tDate;
},
doHandleMonth(month){
  var m = month;
  if (month.toString().length == 1) {
    m = "0" + month;
  }
  return m;
}
}


// WEBPACK FOOTER //
// ./src/utils/globalfunc.js